<template>
<div class="chart-block">
	<canvas id="myChart" width="440" height="320"></canvas>
</div>
</template>

<script>
import Chart from 'chart.js'

export default {
	mounted() {
		let ctx = document.getElementById('myChart')
		let myChart = new Chart(ctx, {
			type: 'line',
			chartArea: {
				backgroundColor: 'rgba(251, 85, 85, 0.4)'
			},
			data: {
				labels: ['2015', '2016', '2017', '2018', '2019'],
				datasets: [
				{
					label: 'First',
					data: [240, 170, 190, 230, 220],
					fill: false,
					borderColor: ['#177dc1'],
					borderWidth: 2,
					pointBackgroundColor: "#177dc1",
					pointRadius: 4,
					backgroundColor: '#177dc1',
					yAxisID: 'yLeft'
				},
				{
					label: 'Second',
					data: [1100, 1800, 1700, 1600, 1790],
					fill: false,
					borderColor: ['#96bb36'],
					borderWidth: 2,
					pointBackgroundColor: "#96bb36",
					pointRadius: 4,
					backgroundColor: '#96bb36',
					yAxisID: 'yRight'
				}]
			},
			options: {
				responsive: false,
				title: {
					display: true,
					text: 'Line Chart'
				},
				hover: {
					mode: 'nearest',
					intersect: true
				},
				scales: {
					xAxes: [{
						display: true,
						scaleLabel: {
							display: true,
							labelString: '(2015-2019)'
						}
					}],
					yAxes: [{
						id: "yRight",
						display: true,
						position: 'right',
						scaleLabel: {
							display: true,
							labelString: 'Number of new companies',
							fontColor: '#96bb36'
						},
						gridLines: { color: "#181818" },
						ticks: {
							beginAtZero: true,
							fontColor: '#96bb36',
							max: 2000,
							min: 0,
							stepSize: 200
						}
					},
					{
						id: "yLeft",
						display: true,
						position: 'left',
						scaleLabel: {
							display: true,
							labelString: 'Jobs created',
							fontColor: '#177dc1'
						},
						ticks: {
							beginAtZero: true,
							fontColor: '#177dc1',
							max: 300,
							min: 0,
							stepSize: 50
						}
					}]
				}
			}
		})
	}
}
</script>

<style lang="scss">
.chart-block {
	height: 320px;
	margin: 0 auto;
	background: #0e0e0e;
}

</style>
